import React, { Component } from "react";
import NewDropdown from "new-react-bootstrap/Dropdown";
import NewMenuItem from "new-react-bootstrap/DropdownItem";

import SearchInput from "@stadium/ui/src/components/search-input/search-input";

import styles from "./main.module.scss";

const Dropdown = (props) => <NewDropdown {...NewDropdown.defaultProps} {...props} />;
const MenuItem = (props) => <NewMenuItem {...NewMenuItem.defaultProps} as="li" {...props} />;
Dropdown.Toggle = (props) => <NewDropdown.Toggle {...NewDropdown.Toggle.defaultProps} {...props} />;
Dropdown.Menu = (props) => (
  <NewDropdown.Menu {...NewDropdown.Menu.defaultProps} as="ul" {...props} />
);

const noOptionDefaultValues = {
  text: "No Result",
  classes: "text-danger no-result-li",
  optionValue: "",
};

const SelectOption = ({
  id,
  text,
  optionValue,
  selectedValue,
  classes = "",
  onClick = () => null,
  isOnlyTextClickableOption = true,
  ...restProps
}) => {
  const onlyTextClickableOption = (
    <MenuItem
      className={`dropdown-item text-decoration-none font-weight-bold fs-10 ${classes}`}
      eventKey={optionValue}
      active={!!selectedValue && selectedValue === optionValue}
      id={`${id}-${optionValue}`}
      {...restProps}
    >
      <a href="#" onClick={(e) => e.preventDefault()}>
        {text}
      </a>
    </MenuItem>
  );
  const entireTileClickableOption = (
    <div onClick={() => onClick({ optionValue })}>{onlyTextClickableOption}</div>
  );

  return isOnlyTextClickableOption ? onlyTextClickableOption : entireTileClickableOption;
};

class SelectDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOptions: props.options,
      isVisible: false,
    };

    this.renderSearchFilter = this.renderSearchFilter.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate({ options: prevOptions }) {
    const { options } = this.props;
    if (options.length != prevOptions.length) {
      this.setState({ dropdownOptions: options });
    }
  }

  onFilter(filteredOptions) {
    this.setState({ dropdownOptions: filteredOptions });
  }
  onClick({ optionValue }) {
    const { onOptionClick } = this.props;
    onOptionClick({ value: optionValue });
  }

  renderSearchFilter() {
    const { options, showSearchFilter, id, searchfilterOptions = {}, name } = this.props;
    const { isVisible } = this.state;

    if (showSearchFilter) {
      return (
        <li
          id={`${id}-search-filter`}
          className="search-filter-input "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <i className="icon-search" />
          <SearchInput
            id={`${id}SearchFilter`}
            name={`${name}SearchFilter`}
            {...searchfilterOptions}
            data={options}
            onFilter={this.onFilter}
            reset={!isVisible}
            focus={isVisible}
          />
        </li>
      );
    }
  }

  renderOptions() {
    const {
      id,
      value: selectedValue,
      noOption = noOptionDefaultValues,
      isOnlyTextClickableOption = true,
    } = this.props;
    const { dropdownOptions } = this.state;

    if (dropdownOptions.length) {
      return dropdownOptions.map(({ text, value: optionValue }) => (
        <SelectOption
          key={`${id}-${optionValue}`}
          id={id}
          text={text}
          optionValue={optionValue}
          selectedValue={selectedValue}
          isOnlyTextClickableOption={isOnlyTextClickableOption}
          onClick={this.onClick}
        />
      ));
    }
    return <SelectOption {...noOption} />;
  }

  onSelect(value) {
    const { onSelect, name } = this.props;
    onSelect?.({ name, value });
  }

  onToggle(isOpen) {
    if (isOpen) {
      this.setState({ isVisible: isOpen });
    } else {
      const { options } = this.props;
      this.setState({ isVisible: isOpen, dropdownOptions: options });
    }
  }

  render() {
    const {
      label = null,
      placeholder = "",
      classes = "",
      id = `select-dropdown-${Date.now()}`,
      value: selectedValue = "",
      error = false,
      text = "",
      disabled = false,
      dropup = false,
      parentLabel = "",
      isParentLabelRequired = false,
      isCloseBtnRequired = false,
      optionsLabel = "",
      isDropDownOpen,
      onClick,
    } = this.props;

    const dropdownClassNames = `dropdown ${error ? "form-input-error" : "countryDD w-100"}`;
    const dropdownToggleClassNames = `dropdown-value ${
      selectedValue ? "" : "dropdown-placeholder-text"
    }`;

    return (
      <>
        {label && (
          <label htmlFor={label.for} className={label.classes}>
            {label.content}
          </label>
        )}
        <div className={`${classes}`}>
          <Dropdown
            id={id}
            className={dropdownClassNames}
            onSelect={this.onSelect}
            onToggle={this.onToggle}
            disabled={disabled}
            dropup={dropup}
            open={isDropDownOpen}
            onClick={onClick}
          >
            <Dropdown.Toggle>
              <>
                <div className={dropdownToggleClassNames}>{selectedValue ? text : placeholder}</div>
                <i className={`${styles.iconChevronDown} icon-chevron-down select-arrow t-cl-1`} />
              </>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {isParentLabelRequired && (
                <div className="language-dropdown-header">{parentLabel}</div>
              )}
              {optionsLabel && <label htmlFor={id}>{optionsLabel}</label>}
              {isCloseBtnRequired && <i className="iconClose" onClick={onClick} />}
              {this.renderSearchFilter()}
              {this.renderOptions()}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>
    );
  }
}

export default SelectDropdown;
